import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import { Link } from 'gatsby'
import { deviceMax } from '../../theme/breakpoints'
import { NAVBAR_HEIGHT } from '../../theme/constants'

export const StyledNavItem = styled.li`
  justify-content: center;
  flex: 1;
  flex-basis: max-content;
  align-items: center;
  display: flex;
  height: inherit;
  font-family: ${({ theme }) => theme.fonts.family};
  text-align: center;
  color: ${({ theme }) => theme.colors.unique.white};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};

  @media ${deviceMax.tablet} {
    font-size: ${({ theme }) => theme.fonts.sizes.md};
    line-height: ${({ theme }) => theme.fonts.lineHeight.md};
  }
`

export const HoverLine = styled.div`
  position: absolute;
  top: ${pxToRem(NAVBAR_HEIGHT.desktop - 5)};
  display: ${({ $isSelected }) => ($isSelected ? 'block' : 'none')};
  border-radius: ${pxToRem(5)} ${pxToRem(5)} 0 0;
  width: 100%;
  height: ${pxToRem(5)};
  background-color: ${({ theme }) => theme.colors.primary.blue};

  @media ${deviceMax.tablet} {
    top: ${pxToRem(NAVBAR_HEIGHT.mobile - 5)};
  }
`

export const StyledLinkGroup = styled.div`
  position: relative;
  display: flex;
  height: inherit;

  &:hover > ${HoverLine} {
    display: block;
  }
`
export const StyledIcon = styled.div`
  align-items: center;
  display: flex;
  margin-right: ${pxToRem(11.63)};
`

export const StyledLink = styled(Link)`
  z-index: 0;
  align-items: center;
  display: flex;
  height: inherit;
  font-size: ${({ theme }) => theme.fonts.oldSizes.md};
`
